import {
  AppBar,
  Badge,
  Box,
  Divider,
  Grid,
  Toolbar,
  Link,
  Theme,
  alpha,
  useTheme,
} from '@mui/material';
import PartnerAccessControlHeader from './partner-access-control-header/partner-access-control-header';
import styles from './partner-access-control.module.scss';
import AWS from 'aws-sdk';
import { useEffect, useState } from 'react';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import PartnerAccessControlTable from './partner-access-control-table/partner-access-control-table';
import PartnerAccessControlNewUser from './partner-access-control-new-user/partner-access-control-new-user';
import {
  CcfAlert,
  CcfBox,
  CcfHelpIcon,
  CcfSnackBar,
  CcfTooltip,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { useMsal } from '@azure/msal-react';
import { authorizePartnersAccess } from 'libs/react/ui-components/src/lib/login/mock-data/authorizePartnersAccess';
// import { s3Config } from '../environments/environment';
import { makeStyles } from '@mui/styles';
import {
  CcfAgentLeg,
  CcfAgentState,
  CcfAppHeader,
} from '@nice-ccf/ui-components';
import partnerAccessControlStyles from './partner-access-control-styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${alpha(theme.palette.common.white, 0.5)}`,
    marginLeft: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 1),
    color: alpha(theme.palette.common.white, 0.5),
    height: '50%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  appHeaderDivider: {
    height: '60%',
    backgroundColor: '#fff',
    opacity: '0.2',
    borderBottomWidth: '40px',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    color: 'white',
    padding: theme.spacing(0.5, 1, 0.5, 0),
    paddingLeft: `calc(1em + ${theme.spacing(3)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '120px',
      '&:focus': {
        width: '120px',
      },
    },
  },
}));

/* eslint-disable-next-line */
export interface PartnerAccessControlProps {}

/**
 * Component displays PartnerAccessControl
 * @param props -PartnerAccessControlProps
 * @returns app header component for landing screen
 * @example <PartnerAccessControl/>
 */
export function PartnerAccessControl(props: PartnerAccessControlProps) {
  const [isTableOpen, setIsTableOpen] = useState(true);
  const theme = useTheme();
  const appHeaderStyles = partnerAccessControlStyles(theme);
  const s3Config = {
    accessKeyId: 'AKIAVFMUJ6SX7NP6G5FY',
    secretAccessKey: '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',
    s3Bucket: window.location.hostname === 'd1u959wi0vug3n.cloudfront.net' ?  'cxone-agent-html-demo-phase2' : 'cxone-agent-demo-app',
    region: 'us-west-2',
  };

  const S3_BUCKET = s3Config.s3Bucket;
  // 'cxone-agent-demo-app';
  const OBJECT_KEY = 'userDB/Users.json';

  AWS.config.update({
    accessKeyId: s3Config.accessKeyId,
    secretAccessKey: s3Config.secretAccessKey,
    region: s3Config.region,
  });

  const s3 = new AWS.S3();

  const initialNewUserFeilds = {
    firstName: '',
    userName: '',
    lastName: '',
    emailAddress: '',
    middleName: '',
    password: '',
  };

  const [allUserDetails, setAllUserDetails]: any = useState([]);
  const [newUserDetails, setNewUserDetails] = useState(initialNewUserFeilds);
  const [rowData, setRowData]: any = useState([]);
  const [rowDataCopy, setRowDataCopy]: any = useState([]);
  const [isUserValid, setIsUserValid]: any = useState(false);

  const [errors, setErrors]: any = useState({
    userName: false,
    password: false,
  });
  const [showToast, setShowToast] = useState(false);
  const [showToastMsg, setShowToastMsg] = useState('');

  const { accounts } = useMsal();
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const loginCredentialsArray = loginCredentialsFromSSO?.split(' ');
  const assignName = `${
    loginCredentialsArray[0].charAt(0).toUpperCase() +
    loginCredentialsArray[0].slice(1).toLowerCase()
  } ${
    loginCredentialsArray[1].charAt(0).toUpperCase() +
    loginCredentialsArray[1].slice(1).toLowerCase()
  }`;

  useEffect(() => {
    if (authorizePartnersAccess.some((x: any) => x.includes(assignName))) {
      setIsUserValid(true);
    }

    /**
     * @param panel- 'contacthistory'
     * @param event - changeevent
     * @param newExpanded - boolean
     * @example - fetchObjectFromS3(panel)
     */ const fetchS3Object = async () => {
      const params = {
        Bucket: S3_BUCKET,
        Key: OBJECT_KEY,
      };

      try {
        const data = await s3.getObject(params).promise();
        const d = JSON.parse(JSON.stringify(data.Body?.toString('utf-8')));
        const userJson = JSON.parse(d);

        const rd = userJson.map((x: any, i: any) => {
          return {
            id: x.id,
            state: x.state,
            name: `${x.firstName} ${x.lastName}`,
            userName: x.userName,
            emailid: x.emailAddress,
            password: x.password,
            actions: x.actions,
          };
        });
        setRowData(rd);
        setRowDataCopy(rd);
        setAllUserDetails(userJson);
      } catch (error) {
        setRowData([]);
        setRowDataCopy([]);

        setAllUserDetails([]);
        console.log('error', error);
      }
    };

    fetchS3Object();
    // uploadToS3(usersData);
  }, []);

  /**
   * @param panel- 'contacthistory'
   * @param event - changeevent
   * @param newExpanded - boolean
   * @example - createUser(panel)
   */
  const uploadToS3 = async (jsonString: any) => {
    const params = {
      Bucket: S3_BUCKET, // Replace with your bucket name
      Key: 'userDB/Users.json', // Replace with the desired file path in your bucket
      Body: JSON.stringify(jsonString), // The JSON string
      ContentType: 'application/json', // Set the content type
    };

    try {
      const data = await s3.putObject(params).promise();
    } catch (err) {
      console.error('Error', err);
    }
    setNewUserDetails(initialNewUserFeilds);
  };

  /**
   * @param panel- 'contacthistory'
   * @param event - changeevent
   * @param newExpanded - boolean
   * @example - createUser(panel)
   */
  const createUser = () => {
    if (newUserDetails && Object.keys(newUserDetails).length) {
      const isUserExist = allUserDetails.some(
        (x: any) => x.userName === newUserDetails.userName
      );

      if (!isUserExist) {
        const newId = rowData && rowData?.length > 0 ? rowData[rowData.length - 1].id + 1 : 1;

        const updatedNewUser = {
          ...newUserDetails,
          id: parseInt(newId, 10),
          state: 'Active',
          actions: ['Active', 'Inactive', 'reset password'],
        };
        const updatedData = allUserDetails;

        const updatedNewUserRowData = {
          ...newUserDetails,
          ...updatedNewUser,
          name: `${updatedNewUser.firstName} ${updatedNewUser.lastName}`,
        };
        setRowData([...rowData, updatedNewUserRowData]);

        setRowDataCopy([...rowData, updatedNewUserRowData]);
        setAllUserDetails([...updatedData, updatedNewUser]);
        uploadToS3([...updatedData, updatedNewUser]);
        setShowToast(true);
        setShowToastMsg('User registration has been completed successfully.');
      } else {
        setShowToast(true);
        setShowToastMsg('The user is already registered.');
        setNewUserDetails(initialNewUserFeilds);
        setErrors({});
      }
    }
    setIsTableOpen(true);
  };

  return (
    <>
     
        <Grid
          sx={{ display: isUserValid ? 'block' : 'None' }}
          style={{
            width: '100%',
            height: '0%',
          }}
          id="partnerAccessContainer"
        >
          <PartnerAccessControlHeader
            isTableOpen={isTableOpen}
            setIsTableOpen={setIsTableOpen}
            createUser={createUser}
            initialNewUserFeilds={initialNewUserFeilds}
            setNewUserDetails={setNewUserDetails}
            newUserDetails={newUserDetails}
            errors={errors}
            setErrors={setErrors}
          />
          {isTableOpen ? (
            <PartnerAccessControlTable
              allUserDetails={allUserDetails}
              setAllUserDetails={setAllUserDetails}
              rowData={rowData}
              setRowData={setRowData}
              setRowDataCopy={setRowDataCopy}
              rowDataCopy={rowDataCopy}
              uploadToS3={uploadToS3}
              setShowToast={setShowToast}
              setShowToastMsg={setShowToastMsg}
              errors={errors}
              setErrors={setErrors}
            />
          ) : (
            <PartnerAccessControlNewUser
              isTableOpen={isTableOpen}
              setIsTableOpen={setIsTableOpen}
              newUserDetails={newUserDetails}
              setNewUserDetails={setNewUserDetails}
              errors={errors}
              setErrors={setErrors}
            />
          )}
          <CcfBox id="partnerAccessAlertContainer">
            <CcfSnackBar
              open={showToast}
              autoHideDuration={3000}
              onClose={() => {
                setShowToast(false);
                setShowToastMsg('');
              }}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
              <div>
                <CcfAlert
                  closeAlert={() => {
                    setShowToast(false);
                    setShowToastMsg('');
                  }}
                  severity="success"
                >
                  {showToastMsg}
                </CcfAlert>
              </div>
            </CcfSnackBar>
          </CcfBox>
        </Grid>{' '}
      

      {!isUserValid && (
        <Grid
          style={{ height: '100%', width: '100%' }}
          sx={{ display: !isUserValid ? 'block' : 'None' }}
          id="partnerAccessNotFoundContainer"
        >
          <div
            style={{ textAlign: 'center', marginTop: '50px', height: '100%' }}
          >
            <CcfTypography style={{ fontWeight: '600' }}>
              404 - Not Found
            </CcfTypography>
            <CcfTypography style={{ fontWeight: '600' }}>
              You are not authorized to access this page.
            </CcfTypography>
          </div>
        </Grid>
      )}
    </>
  );
}

export default PartnerAccessControl;
